import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useAuditorFrameworks } from '@/api/hooks/useAuditorAccess';

export function AuditorFrameworkListPage() {
  const { data: frameworks, isLoading } = useAuditorFrameworks();

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold text-text-primary">Frameworks</h1>
      {isLoading ? (
        <div className="space-y-3">
          {[1,2,3].map(i => <Skeleton key={i} className="h-20 rounded-xl" />)}
        </div>
      ) : (frameworks ?? []).length === 0 ? (
        <p className="text-text-tertiary">No frameworks in scope</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {(frameworks ?? []).map((fw) => (
            <Link key={fw.id} to={`/auditor/frameworks/${fw.id}`}>
              <Card className="hover:border-accent-cyan transition-colors cursor-pointer">
                <CardContent className="p-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="font-medium text-text-primary">{fw.displayName}</p>
                      <p className="text-xs text-text-tertiary">{fw.name} v{fw.version}</p>
                    </div>
                    <ArrowRight className="h-4 w-4 text-text-tertiary mt-1" />
                  </div>
                  <div className="mt-3">
                    <div className="flex justify-between text-xs text-text-secondary mb-1">
                      <span>{fw.totalControls} controls</span>
                      <span>{fw.readinessPct != null ? `${fw.readinessPct}% ready` : '—'}</span>
                    </div>
                    <div className="h-1.5 w-full rounded-full bg-bg-surface-2">
                      <div
                        className="h-1.5 rounded-full bg-accent-cyan"
                        style={{ width: `${fw.readinessPct ?? 0}%` }}
                      />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
